import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/quality-assurance/audits-and-remediation")({
  beforeLoad: () => { throw redirect({ to: "/zh-cn/services/quality-assurance/integrated-audit-solutions", statusCode: 301 }); },
});
